document.addEventListener("DOMContentLoaded", function() {
  function updateLiveVisitors() {
    let visitors = Math.floor(Math.random() * (60 - 15 + 1)) + 15;
    document.getElementById("live-visitors").textContent = visitors;
  }

  function updateCartAdds() {
    let cartAdds = Math.floor(Math.random() * (7 - 2 + 1)) + 2;
    document.getElementById("cart-adds").textContent = cartAdds;
  }

  // Initial Updates
  updateLiveVisitors();
  updateCartAdds();

  // Auto Update Every 5s and 90s
  setInterval(updateLiveVisitors, 5000);
  setInterval(updateCartAdds, 90000);
});